import React, { useState } from 'react';
import { Container, Box, ToggleButton, ToggleButtonGroup, Typography, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SupplierTab from './resources/SupplierTab';
import TourTab from './resources/TourTab';
import FinancialAccountTab from './resources/FinancialAccountTab';
import HumanResourceTab from './resources/HumanResourceTab';
import TransportRouteTab from './resources/TransportRouteTab';
import HotelRoomTab from './resources/HotelRoomTab';

const resourceTheme = createTheme({
    typography: {
        fontFamily: "'Roboto', 'Arial', sans-serif",
        button: {
            textTransform: 'none', 
            fontWeight: 'bold'
        },
        allVariants: {
            fontFeatureSettings: "'cv11', 'ss01'",
        }
    },
    shape: { borderRadius: 8 },
    palette: { primary: { main: '#007373' } },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 'bold' }
        }
      }
    }
});

function ResourceManagement() {
  // 1. KHAI BÁO USER ROLE Ở ĐÂY (Lấy từ localStorage)
  const userRole = localStorage.getItem('user_role') || 'SALE';

  const [viewMode, setViewMode] = useState('TOUR'); 
  const [refreshKey, setRefreshKey] = useState(0);
  const [openAdd, setOpenAdd] = useState(false);

  const getAddLabel = () => {
      switch(viewMode) {
          case 'TOUR': return 'Tour';
          case 'TRANSPORT_ROUTE': return 'Tuyến xe';
          case 'HOTEL_ROOM': return 'Phòng KS';
          case 'SUPPLIER': return 'NCC';
          case 'ACCOUNT': return 'TK'; 
          case 'HR': return 'Nhân sự';
          default: return '';
      }
  }

  const handleRefresh = () => setRefreshKey(prev => prev + 1);

  return (
    <ThemeProvider theme={resourceTheme}>
      <Container maxWidth={false} sx={{ mt: 3, mb: 3, maxWidth: '1400px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#007373' }}>
            QUẢN LÝ NGUỒN CUNG
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              // 2. TRẢ LẠI HÀM ONCHANGE GỐC
              onChange={(e, newMode) => { if (newMode) setViewMode(newMode); }}
              size="small"
              sx={{ bgcolor: 'white' }}
            >
              <ToggleButton value="TOUR" sx={{ px: 3 }}>Tour</ToggleButton>
              <ToggleButton value="TRANSPORT_ROUTE" sx={{ px: 3 }}>Xe</ToggleButton>
              <ToggleButton value="HOTEL_ROOM" sx={{ px: 3 }}>Hotel</ToggleButton>
              <ToggleButton value="SUPPLIER" sx={{ px: 3 }}>NCC</ToggleButton>
              
              {/* 3. CHỈ MANAGER MỚI ĐƯỢC XEM TAB ACCOUNT VÀ HR */}
              {userRole === 'MANAGER' && <ToggleButton value="ACCOUNT" sx={{ px: 3 }}>Account</ToggleButton>}
              {userRole === 'MANAGER' && <ToggleButton value="HR" sx={{ px: 3 }}>HR</ToggleButton>}
            </ToggleButtonGroup>

            {/* 4. CHỈ MANAGER VÀ SOURCING MỚI THẤY NÚT THÊM MỚI */}
            {['MANAGER', 'SOURCING'].includes(userRole) && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setOpenAdd(true)}
                  sx={{ bgcolor: '#007373', '&:hover': { bgcolor: '#005c5c' } }}
                >
                  Thêm mới {getAddLabel()}
                </Button>
            )}

            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleRefresh}
              sx={{ bgcolor: 'white' }}
            >
              Làm mới
            </Button>
          </Box>
        </Box>

        <Box key={refreshKey}>
          {viewMode === 'TOUR' && <TourTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
          {viewMode === 'TRANSPORT_ROUTE' && <TransportRouteTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
          {viewMode === 'HOTEL_ROOM' && <HotelRoomTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
          {viewMode === 'SUPPLIER' && <SupplierTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
          {viewMode === 'ACCOUNT' && <FinancialAccountTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
          {viewMode === 'HR' && <HumanResourceTab openAddSignal={openAdd} onCloseAdd={() => setOpenAdd(false)} />}
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default ResourceManagement;